<div fxLayout="row" class="flexwrap">

  <div fxFlex="50" fxFlex.lt-md="100%">

    <!-- STRING -->
    @if (data.field.idTypeField == 1) {
      <div>
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'protocolEdit.dialog.essay.' + data.field.translationField + '.label' | translate }} {{ 'common.inProtocol' | translate }}</mat-label>
          <input matInput disabled="true" (ngModelChange)="setValue(tab.idVariable, field, -1, $event)"
            [required]="data.field.required" [name]="data.field.translationField"
            [ngModel]="data.field.valueProtocol" [errorStateMatcher]="matcher">
          <mat-error>
            {{ 'protocolEdit.dialog.essay.' + data.field.translationField + '.error' | translate }}
          </mat-error>
        </mat-form-field>
      </div>
    }

    <!-- NUMÉRICO -->
    @if (data.field.idTypeField == 2) {
      <div>
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'protocolEdit.dialog.essay.' + data.field.translationField + '.label' | translate }} {{ 'common.inProtocol' | translate }}</mat-label>
          <input matInput disabled="true" [name]="data.field.translationField"
            [ngModel]="data.field.valueProtocol" [errorStateMatcher]="matcher"
            (ngModelChange)="setValue(tab.idVariable, field, -1, $event)" type="number"
            [required]="data.field.required">
          <mat-error>
            {{ 'protocolEdit.dialog.essay.' + data.field.translationField + '.error' | translate }}
          </mat-error>
        </mat-form-field>
      </div>
    }

    <!-- TOLERANCIA -->
    @if (data.field.idTypeField == 3) {
      <div>
        <div fxFlex="35%" fxFlex.lt-md="100%">
          <mat-form-field class="campoFormulario">
            <mat-label>{{ 'protocolEdit.dialog.essay.' + data.field.translationField + '.label' | translate }} {{ 'common.inProtocol' | translate }}</mat-label>
            <input matInput disabled="true" [name]="data.field.translationField" type="number"
              [required]="data.field.required" [ngModel]="data.field.valueProtocolArray[0]">
            <mat-error>
              {{ 'protocolEdit.dialog.essay.' + data.field.translationField + '.error' | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div fxFlex="35%" fxFlex.lt-md="100%">
          ±
          <mat-form-field class="campoFormulario">
            <mat-label>{{ 'protocolEdit.dialog.essay.valueTolerance.label' | translate }} {{ 'common.inProtocol' | translate }}</mat-label>
            <input matInput disabled="true" [name]="data.field.translationField + 'Tolerance'" type="number"
              [required]="data.field.required" [ngModel]="data.field.valueProtocolArray[1]">
            <mat-error>
              {{ 'protocolEdit.dialog.essay.valueTolerance.error' | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    }

    <!-- DIA HORA MIN -->
    @if (data.field.idTypeField == 4) {
      <div>
        <div fxLayout="row">
          <div fxFlex="32%" fxFlex.lt-md="100%">
            <mat-form-field class="campoFormulario">
              <mat-label>{{ 'protocolEdit.dialog.essay.' + data.field.translationField + '.label' | translate }}: {{ 'common.days.label' | translate }} {{ 'common.inProtocol' | translate }}</mat-label>
              <input matInput [name]="data.field.translationField + 'DayProt'" disabled="true" type="number"
                [required]="data.field.required" [ngModel]="data.field.valueProtocolArray[0]">
            </mat-form-field>
          </div>
          <div fxFlex="32%" fxFlex.lt-md="100%">
            <mat-form-field class="campoFormulario">
              <mat-label>{{ 'common.hours.label' | translate }}</mat-label>
              <input matInput [name]="data.field.translationField + 'HourProt'" type="number" disabled="true"
                [required]="data.field.required" [ngModel]="data.field.valueProtocolArray[1]">
            </mat-form-field>
          </div>
          <div fxFlex="32%" fxFlex.lt-md="100%">
            <mat-form-field class="campoFormulario">
              <mat-label>{{ 'common.minutes.label' | translate }}</mat-label>
              <input matInput [name]="data.field.translationField + 'MinProt'" type="number" disabled="true"
                [required]="data.field.required" [ngModel]="data.field.valueProtocolArray[2]">
            </mat-form-field>
          </div>
        </div>
      </div>
    }

    <!-- SELECT_ONE -->
    @if (data.field.idTypeField == 6) {
      <div>
        <span>
          {{ 'protocolEdit.dialog.essay.' + data.field.translationField + '.label' | translate }}
          {{ 'common.inProtocol' | translate }}
        </span>
        <br />
        <mat-radio-group class="vertical-radio-group" [required]="data.field.required">
          @for (doma of data.field.fieldDomain; track doma) {
            <mat-radio-button class="vertical-radio-button"
              [value]="doma.value" disabled="true">
              {{ 'protocolEdit.dialog.essay.' + doma.translation + '.label' | translate }}
            </mat-radio-button>
          }
        </mat-radio-group>
      </div>
    }

    <!-- SELECT_MULTI -->
    @if (data.field.idTypeField == 7) {
      <div>
        <span>
          {{ 'protocolEdit.dialog.essay.' + data.field.translationField + '.label' | translate }}
          {{ 'common.inProtocol' | translate }}
        </span>
        <mat-selection-list disabled="true">
          @for (doma of data.field.fieldDomain; track doma) {
            <mat-list-option checkboxPosition="before" disabled="true"
              [value]="doma.value" [selected]="isSelectedMulti(data.field.valueProtocol, doma.value)">
              {{ 'protocolEdit.dialog.essay.' + doma.translation + '.label' | translate }}
            </mat-list-option>
          }
        </mat-selection-list>
      </div>
    }

    <!-- BOOLEAN -->
    @if (data.field.idTypeField == 8) {
      <div>
        <mat-checkbox [value]="data.field.valueProtocol" disabled="true">
          {{ 'protocolEdit.dialog.essay.' + data.field.translationField + '.label' | translate }}
          {{ 'common.inProtocol' | translate }}
        </mat-checkbox>
      </div>
    }

  </div>

  <div fxFlex="50" fxFlex.lt-md="100%">

    <!-- STRING -->
    @if (data.field.idTypeField == 1) {
      <div>
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'protocolEdit.dialog.essay.' + data.field.translationField + '.label' | translate }}</mat-label>
          <input matInput [name]="data.field.translationField" [(ngModel)]="data.field.value"
            [errorStateMatcher]="matcher" (ngModelChange)="setValue(-1, $event)" [disabled]="data.disabled"
            [required]="data.field.required">
          <mat-error>
            {{ 'protocolEdit.dialog.essay.' + data.field.translationField + '.error' | translate }}
          </mat-error>
        </mat-form-field>
      </div>
    }

    <!-- NUMÉRICO -->
    @if (data.field.idTypeField == 2) {
      <div>
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'protocolEdit.dialog.essay.' + data.field.translationField + '.label' | translate }}</mat-label>
          <input matInput [name]="data.field.translationField" [(ngModel)]="data.field.value"
            (ngModelChange)="setValue(-1, $event)" type="number" [disabled]="data.disabled"
            [errorStateMatcher]="matcher" [required]="data.field.required">
          <mat-error>
            {{ 'protocolEdit.dialog.essay.' + data.field.translationField + '.error' | translate }}
          </mat-error>
        </mat-form-field>
      </div>
    }

    <!-- TOLERANCIA -->
    @if (data.field.idTypeField == 3) {
      <div>
        <div fxFlex="40%" fxFlex.lt-md="100%">
          <mat-form-field class="campoFormulario">
            <mat-label>{{ 'protocolEdit.dialog.essay.' + data.field.translationField + '.label' | translate }}</mat-label>
            <input matInput [name]="data.field.translationField" [(ngModel)]="data.field.value[0]" type="number"
              (ngModelChange)="setValue(0, $event)" [errorStateMatcher]="matcher" [disabled]="data.disabled"
              [required]="data.field.required">
            <mat-error>
              {{ 'protocolEdit.dialog.essay.' + data.field.translationField + '.error' | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div fxFlex="40%" fxFlex.lt-md="100%">
          ±
          <mat-form-field class="campoFormulario">
            <mat-label>{{ 'protocolEdit.dialog.essay.valueTolerance.label' | translate }}</mat-label>
            <input matInput
              [name]="data.field.translationField + 'Tolerance'" [(ngModel)]="data.field.value[1]"
              (ngModelChange)="setValue(1, $event)" [errorStateMatcher]="matcher" type="number"
              [disabled]="data.disabled" [required]="data.field.required">
            <mat-error>
              {{ 'protocolEdit.dialog.essay.valueTolerance.error' | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    }

    <!-- DIA HORA MIN -->
    @if (data.field.idTypeField == 4) {
      <div>
        <div fxLayout="row">
          <div fxFlex="34%" fxFlex.lt-md="100%">
            <mat-form-field class="campoFormulario">
              <mat-label>{{ 'protocolEdit.dialog.essay.' + data.field.translationField + '.label' | translate }}: {{ 'common.days.label' | translate }}</mat-label>
              <input matInput [name]="data.field.translationField + 'Day'" [(ngModel)]="data.field.value[0]"
                (ngModelChange)="setValue(0, $event)" [errorStateMatcher]="matcher" type="number"
                [disabled]="data.disabled" [required]="data.field.required" min="0">
            </mat-form-field>
          </div>
          <div fxFlex="33%" fxFlex.lt-md="100%">
            <mat-form-field class="campoFormulario">
              <mat-label>{{ 'common.hours.label' | translate }}</mat-label>
              <input matInput [name]="data.field.translationField + 'Hour'" [(ngModel)]="data.field.value[1]"
                (ngModelChange)="setValue(1, $event)" [errorStateMatcher]="matcher" type="number"
                [disabled]="data.disabled" [required]="data.field.required" min="0">
            </mat-form-field>
          </div>
          <div fxFlex="33%" fxFlex.lt-md="100%">
            <mat-form-field class="campoFormulario">
              <mat-label>{{ 'common.minutes.label' | translate }}</mat-label>
              <input matInput [name]="data.field.translationField + 'Minute'"
                [(ngModel)]="data.field.value[2]" (ngModelChange)="setValue(2, $event)"
                [errorStateMatcher]="matcher" type="number" [disabled]="data.disabled"
                [required]="data.field.required" min="0">
            </mat-form-field>
          </div>
        </div>
      </div>
    }

    <!-- SELECT_ONE -->
    @if (data.field.idTypeField == 6) {
      <div>
        <span>
          {{ 'protocolEdit.dialog.essay.' + data.field.translationField + '.label' | translate }}
        </span>
        <br />
        <mat-radio-group class="vertical-radio-group" [required]="data.field.required">
          @for (doma of data.field.fieldDomain; track doma) {
            <mat-radio-button class="vertical-radio-button"
              [value]="doma.value">
              {{ 'protocolEdit.dialog.essay.' + doma.translation + '.label' | translate }}
            </mat-radio-button>
          }
        </mat-radio-group>
      </div>
    }

    <!-- SELECT_MULTI -->
    @if (data.field.idTypeField == 7) {
      <div>
        <span>
          {{ 'protocolEdit.dialog.essay.' + data.field.translationField + '.label' | translate }}
          @if (data.field.required) {
            <span>*</span>
          }
        </span>
        <mat-selection-list [disabled]="data.disabled" (selectionChange)="setValue(-1, $event)">
          @for (doma of data.field.fieldDomain; track doma) {
            <mat-list-option checkboxPosition="before"
              [disabled]="data.disabled" [value]="doma.value"
              [selected]="isSelectedMulti(data.field.value, doma.value)">
              {{ 'protocolEdit.dialog.essay.' + doma.translation + '.label' | translate }}
            </mat-list-option>
          }
        </mat-selection-list>
      </div>
    }

    <!-- BOOLEAN -->
    @if (data.field.idTypeField == 8) {
      <div>
        <mat-checkbox [value]="data.field.value" [checked]="data.field.value == 'true'" [disabled]="data.disabled"
          (change)="setValue(-1, $event)">
          {{ 'protocolEdit.dialog.essay.' + data.field.translationField + '.label' | translate }}
        </mat-checkbox>
      </div>
    }

  </div>

  @if (showReason()) {
    <div fxFlex="100">
      <mat-label>{{ 'common.reasonChange' | translate }}</mat-label>
      <textarea rows="5" matAutosizeMinRows="5" matInput
        [(ngModel)]="data.field.valueChangeReason" name="locationChangeReason" required
      style="resize: none;"></textarea>
    </div>
  }

  <div fxLayout="column" class="flexwrap">
    <div fxFlex="100">
      <mat-checkbox name="showDiffInDeviations" [(ngModel)]="data.field.showDiffInDeviations">
        {{ 'protocolEdit.dialog.essay.criteria.showDiffInDeviations.label' | translate }}
      </mat-checkbox>
    </div>
    <div fxFlex="100">
      <mat-checkbox name="showDiffInObservations" [(ngModel)]="data.field.showDiffInObservations">
        {{ 'protocolEdit.dialog.essay.criteria.showDiffInObservations.label' | translate }}
      </mat-checkbox>
    </div>
  </div>

</div>

<div mat-dialog-actions class="thermal-theme">
  <div fxFlex></div>
  <button mat-raised-button color="primary" (click)="onOkClick()">{{ 'button.save' | translate }}</button>
  <button mat-raised-button color="secondary" (click)="onNoClick()">{{ 'button.cancel' | translate }}</button>
</div>